if($('aside.sidebar').length){
    $('.sidebar-inner').prepend('<div class="sidebarCart"><div class="h6">'+nakupnikosik+'</div></div>');
    shoptet.global.showPopupWindow('cart', true);
    $('body').removeClass('user-action-visible')
    $('.sidebarCart').append($('.popup-widget.cart-widget'));
    $('a[data-target="cart"]').removeClass('toggle-window');
    $('html').on('click', '.sidebarCart .h6', function(){
        $(this).next('#cart-widget').slideToggle();
        $('.sidebarCart').toggleClass('cartClosed')
    });
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        shoptet.global.showPopupWindow('cart', true);
    });
    document.addEventListener('ShoptetCartUpdated', function() {
        shoptet.global.showPopupWindow('cart', true);
    });
    
    
};